<template>
  <div :class="classes" v-loading="loading">
    <pt-page-title title="异常订单处理" :isSearch="true" @search="search" @emptySearch="emptySearch" :searchKey="searchKey"></pt-page-title>
    <!-- tabs -->
    <el-tabs v-model="currentStatusFilter" @tab-click="handleClick" slot="title">
      <!-- TZ: 待处理里不显示WAITING_FOR_JOB -->
      <el-tab-pane label="待创建" name="CREATE"></el-tab-pane>
      <el-tab-pane label="待处理" name="ACTION_REQUIRED"></el-tab-pane>
      <el-tab-pane label="已处理" name="COMPLETED,WAITING_FOR_NEW_ORDER"></el-tab-pane>
    </el-tabs>
    <!-- 筛选 -->
    <div style="overflow:hidden">
      <pt-page-factor-filter :labels="filterLabels" v-model="filterForm" v-if="currentStatusFilter!=='CREATE'" style="display:inline-block">
        <!-- <el-button type="primary" @click="handleFilter">筛选</el-button> -->
      </pt-page-factor-filter>
      <!-- <el-button type="primary" @click="operateDialogVisible = true" :disabled="!showOperation" style="text-align: end;">批量操作</el-button> -->
      <div style="padding:.2rem;float: right;display: inline-block;" v-if="currentStatusFilter!=='COMPLETED,WAITING_FOR_NEW_ORDER'">
        <el-button type="primary" @click.native="operateDialogVisible = true">批量操作</el-button>
      </div>
    </div>
    <!-- 表格 -->
    <pt-order-handle-table v-if="showTable" :tableLabels="currentTableLabels" :status="currentStatusFilter" ref="table" @updateSelectedData="updateSelectedData" :isSelect="showOperation">
      <el-table-column label="操作" v-if="showOperation" fixed="right" min-width="200">
        <template slot-scope="scope">
          <task-operate :task="scope.row" @on-success="onSuccess" @before-submit="showLoading" @on-error="onError"></task-operate>
        </template>
      </el-table-column>
    </pt-order-handle-table>
    <!-- 批量处理的dialog -->
    <lot-operate-dialog :dialogVisible="operateDialogVisible" :handle-close="closeDialog" :rows="selected" :title="dialogTitle" @on-success="onSuccess" @before-submit="showLoading" @on-error="onError" @deleteRow="deleteRow"></lot-operate-dialog>
  </div>
</template>

<script>
// 组件class前缀
import { filterFactor, tableLabels, tableLabelsOk, tableLabelsCreated } from './order-handle-options.js'
import ptOrderHandleTable from './pt-order-handle-table/withData'
import taskOperate from 'cps/lab-order/order-status/form/components/task-operate'
import lotOperateDialog from './lot-operate-dialog'
import { formatActionAcceptableResult } from 'enumeration/lab-order.js'
const prefixCls = 'pt-order-handle'
export default {
  name: 'pt-order-handle',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    currentTableLabels () {
      if (this.currentStatusFilter === 'COMPLETED,WAITING_FOR_NEW_ORDER') {
        return tableLabelsOk
      }
      if (this.currentStatusFilter === 'CREATE') {
        return tableLabelsCreated
      }
      return tableLabels
    },
    dialogTitle () {
      let status = Array.from(new Set(this.selected.map(e => e.orderActionData.nextAction)))
      if (status && status.length === 1) {
        return `${status[0]}异常-批量操作`
      }
      return ``
    },
    showOperation () {
      return this.currentStatusFilter === 'ACTION_REQUIRED' || this.currentStatusFilter === 'CREATE'
    }
  },
  components: {
    ptOrderHandleTable,
    taskOperate,
    lotOperateDialog
    // 'order-handle-dialog': dialog
  },
  watch: {
    selected (val) {
      console.log(val)
      // this.handleRowsTitle
    },
    filterForm (val) {
      console.log(val)
      this.handleFilter()
    }
  },
  data () {
    return {
      searchKey: '',
      loading: false,
      filterLabels: filterFactor,
      filterForm: {},
      currentStatusFilter: this.$route.params.status,
      dialogVisible: false,
      currentSampleId: '',
      // 操作
      operate: '',
      submitParams: {},
      saveFileName: '',
      operateDialogVisible: false,
      selected: [],
      showTable: true
    }
  },
  methods: {
    emptySearch () {
      this.searchKey = ''
      let data = this.filterForm
      data.searchKey = ''
      data.pageable = { page: 0, size: 24 }
      data.status = this.currentStatusFilter.split(',')
      this.$nextTick(_ => {
        this.$refs.table.reload(data)
      })
    },
    search (val) {
      if (!val) return
      this.searchKey = val
      let data = this.filterForm
      data.searchKey = val
      data.pageable = { page: 0, size: 24 }
      data.status = this.currentStatusFilter.split(',')
      this.$nextTick(_ => {
        this.$refs.table.reload(data)
      })
    },
    formatActionAcceptableResult,
    deleteRow (row) {
      this.selected = this.selected.filter(e => e.id !== row.id)
      this.$refs.table.updateSelected(row)
    },
    handleClick (tab) {
      this.filterForm = {}
      this.handleFilter()
      this.$router.push({ name: 'order-handle', params: { status: tab.name } })
      this.showTable = false
      this.$nextTick(_ => {
        this.showTable = true
      })
    },
    handleFilter () {
      this.searchKey = ''
      this.filterForm.searchKey = ''
      let data = this.filterForm
      if (data.orderActions === '') {
        data.orderActions = null
      }
      data.status = this.currentStatusFilter.split(',')
      data.pageable = { page: 0, size: 10 }
      this.$refs.table && this.$refs.table.reload(data)
    },
    closeDialog () {
      // this.selected = []
      this.operateDialogVisible = false
    },
    async submit (data) {
      console.log('data----', data)
      this.loading = true
      if (data) {
        if (data.sampleRecollectCost) {
          this.submitParams.sampleRecollectCost = Number(data.sampleRecollectCost) * 100// 重采
          return this.$store.dispatch('pendingTasksSubmit', this.submitParams)
        }
        if (data.file) {
          // let uploadParams = new FormData(data.file)
          // uploadParams.append('file', data.file)
          try {
            let file = data.file
            let params = { resourceConfig: 'mutationVerify', type: 'PRIVATE_RESOURCE', file: file, fileNameNoUrl: data.file.name }
            var uploadRes = await this.$store.dispatch('ossUploadBigFile', params)
            if (uploadRes.status === 204) {
              // ---对应字段
              let fileObj = {}
              fileObj.ossUrl = uploadRes.fileNameNoUrl ? uploadRes.fileNameNoUrl : null
              fileObj.type = 'VERIFICATION_REQUEST'
              fileObj.name = data.file.name
              this.submitParams.attachment = {
                ossUrl: uploadRes.fileNameNoUrl ? uploadRes.fileNameNoUrl : null,
                type: 'VERIFICATION_REQUEST',
                name: data.file.name
              }
              return this.$store.dispatch('pendingTasksSubmit', this.submitParams)
            } else {
              this.loading = false
              this.$message.error('文件上传失败')
            }
          } catch (err) {
            this.loading = false
            this.$message.error('文件上传失败！')
          }
        }
      }
      return this.$store.dispatch('pendingTasksSubmit', this.submitParams)
    },
    onSuccess () {
      this.hideLoading()
      this.selected = []
      this.$refs.table.getDataList()
      this.$refs.table.clearSelection()
    },
    showLoading () {
      this.loading = true
    },
    hideLoading () {
      this.loading = false
    },
    onError () {
      this.hideLoading()
    },
    certainSubmit (data) {
      this.submit(data).then(res => {
        this.loading = false
        if (res.message) {
          this.$message.warning(res.message)
        } else {
          this.$message.success('操作成功！')
        }
        this.$refs.table.reload()
        console.log('res', res)
      }).catch(err => {
        this.loading = false
        this.$message.warning(err)
      })
    },
    updateSelectedData (rows) {
      this.selected = rows
    }
  }

}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-order-handle {
  .el-tabs {
    display: inline-block;
  }
  .el-tabs--top .el-tabs__nav {
    padding-left: 30px;
    padding-right: 30px;
    .el-tabs__item {
      font-size: 16px;
    }
  }
  .el-tabs__active-bar {
    left: 30px;
  }
  .el-button--mini {
    margin-bottom: 10px;
  }
}
</style>
